import React from 'react';
import PropTypes from 'prop-types';

import Styles from './ConfigsList.styles';


const ConfigsList = ({ children }) => (
  <div className={Styles.default}>
    {children}
  </div>
);

ConfigsList.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ConfigsList;
